module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /Users/sameer/Documents/projects/release/metabase/~/readable-stream/lib/internal/streams/stream-browser.js
// module id = 556
// module chunks = 0 3 5